'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';

import Why from '@/components/home-page/whySection';
import ContactForm from '@/components/home-page/ContactForm';
import FAQContainer from '@/components/home-page/FAQContainer';
import Footer from '@/components/footer/Footer';


const ContactForms: React.FC = () => {




  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}
    <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/about.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
   About Us
  </h1>
    
  </div>
 

  <NavBar />
 <div
      className=
        "grid grid-cols-1  lg:grid-cols-2 bg-background "
    >
        <div  className='bg-secondary p-6 lg:p-32'>
      {/* Thumbnail / play trigger */}
            <h2 className="text-5xl xl:text-9xl text-primary font-extrabold uppercase">
          Built On Experience
        </h2>
        <p className="text-2xl lg:text-5xl font-semibold text-white">as Your Web Developement Company Partner</p>
</div>
      {/* Text content */}
      <div className="space-y-8 p-6 lg:p-32">

        <p className=" max-w-prose lg:text-xl leading-relaxed text-neutral-600">
        We're a team that has spent years in the trenches of web development — building, testing, breaking things, and learning how to build them better. That experience shows up in every line of code we write and every decision we make on your behalf. We don't believe in cookie-cutter solutions, because your business isn't a template, and neither is our approach to it.
        </p>
        <p className=" max-w-prose lg:text-xl leading-relaxed text-neutral-600">
        Every project starts with a simple question: what does success look like for you? From there, we bring our craft, our curiosity, and our care to build something that feels genuinely yours — not just functional, but memorable. This is what we mean by a unique experience: not just a website, but a digital home you're proud to show the world.
        </p>
      </div>
    </div>



















    <div
      className=
        "grid grid-cols-1  lg:grid-cols-2 bg-primary  "
    >
       
      {/* Text content */}
      <div className="space-y-8 p-6 lg:p-32 text-white">

        <p className=" max-w-prose lg:text-xl leading-relaxed">
        At the end of the day, this isn't about us — it's about you. You're the one with the vision, the story, and the business you've worked hard to build. Our job is to give that vision a voice online, and to make sure it's heard clearly, loudly, and beautifully. You're the hero of this story; we're just here to help you tell it right.
        </p>
        <p className=" max-w-prose lg:text-xl leading-relaxed">
        That's why we treat every partnership as exactly that — a partnership. We listen first, ask the right questions, and stay by your side through every stage of the journey, from the first sketch to the final launch and beyond. Your wins are our wins, and nothing makes us prouder than watching a client we've worked with grow, thrive, and succeed.
        </p>

        <div className="flex justify-end">
  
</div>



      </div>
 <div  className='bg-secondary p-6 lg:p-32'>
      {/* Thumbnail / play trigger */}
            <h2 className="text-5xl xl:text-9xl text-white font-extrabold uppercase">
          You Are The Hero
        </h2>
       
</div>
    </div>
<ContactForm/>
<Footer/>
</>
  );
};

export default ContactForms;